import { Component } from '@angular/core';
import { DataServiceService } from './service/data-service.service';



@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})

export class AppComponent {
  Total:number;
  Today:string;
  constructor(private dataServiceService: DataServiceService) { }

  ngOnInit() {
    this.GetOnline();
    this.Today = new Date().getFullYear().toString() + "-" + (new Date().getMonth() + 1).toString() + "-" + new Date().getDate();
  }

  GetOnline() {
    this.dataServiceService.getOnline().subscribe(x => {
      this.Total = x.Total
      console.log(this.Total);
    });
  }
}

